import React from "react";
import { Chart, ChartArea, ChartLegend, ChartSeries, ChartSeriesItem, ChartTooltip, ChartXAxis, ChartXAxisItem, ChartYAxis, ChartYAxisItem } from "@progress/kendo-react-charts";

interface EfficiencyCurveProps {
    chart3Data?: any;
}

const PowerCurve: React.FC<EfficiencyCurveProps> = ({ chart3Data }) => {
    return (
        <div>
            {chart3Data && (
                <Chart>
                    <ChartArea background="transparent" />

                    {/* Legend */}
                    <ChartLegend
                        position="bottom"
                        labels={{ font: "16px Mulish", color: "#fff" }}
                    />

                    {/* Series */}
                    <ChartSeries>
                        <ChartSeriesItem
                            name="45 Hz"
                            type="scatterLine"
                            data={chart3Data?.series?.[0]?.data}
                            xField="capacity"
                            yField="head"
                            color="#FF0000"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="50 Hz"
                            type="scatterLine"
                            data={chart3Data?.series?.[1]?.data}
                            xField="capacity"
                            yField="power"
                            color="#FF0000"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: false, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="55 Hz"
                            type="scatterLine"
                            data={chart3Data?.series?.[2]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#FF0000"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="60 Hz"
                            type="scatterLine"
                            data={chart3Data?.series?.[3]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#FF0000"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="65 Hz"
                            type="scatterLine"
                            data={chart3Data?.series?.[4]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#FF0000"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="70 Hz"
                            type="scatterLine"
                            data={chart3Data?.series?.[5]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#FF0000"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="75 Hz"
                            type="scatterLine"
                            data={chart3Data?.series?.[6]?.data}
                            xField="capacity"
                            yField="efficiency"
                            color="#FF0000"
                            yAxis="Head"
                            style="smooth"
                            markers={{ visible: false }}
                            width={4.0}
                            tooltip={{ visible: true, format: "{0} x {1}", color: "#FFF" }}
                        />
                        <ChartSeriesItem
                            name="Min"
                            type="scatterLine"
                            dashType="longDash"
                            data={chart3Data?.series?.[7]?.data}
                            xField="capacity"
                            yField="head"
                            color="#737373"
                            yAxis="Head"
                            markers={{
                                visible: false,
                                type: "square",
                                background: "black",
                                size: 10,
                            }}
                            width={2.0}
                            labels={{
                                visible: false,
                                background: "#bfbfbf",
                                border: {
                                    width: 1,
                                    color: "black",
                                },
                                font: "11px calibri",
                            }}
                            tooltip={{
                                visible: true,
                                format: "{0} x {1}",
                                color: "#FFF",
                            }}
                            visibleInLegend={false}
                        />
                        <ChartSeriesItem
                            name="Max"
                            type="scatterLine"
                            dashType="longDash"
                            data={chart3Data?.series?.[8]?.data}
                            xField="capacity"
                            yField="head"
                            color="#737373"
                            yAxis="Head"
                            markers={{
                                visible: false,
                                type: "square",
                                background: "black",
                                size: 10,
                            }}
                            width={2.0}
                            labels={{
                                visible: false,
                                background: "#bfbfbf",
                                border: {
                                    width: 1,
                                    color: "black",
                                },
                                font: "11px calibri",
                            }}
                            tooltip={{
                                visible: true,
                                format: "{0} x {1}",
                                color: "#FFF",
                            }}
                            visibleInLegend={false}
                        />
                        <ChartSeriesItem
                            name="BEP"
                            type="scatterLine"
                            dashType="longDash"
                            data={chart3Data?.series?.[9]?.data}
                            xField="capacity"
                            yField="head"
                            color="#FF0000"
                            yAxis="Head"
                            markers={{
                                visible: false,
                                type: "square",
                                background: "black",
                                size: 10,
                            }}
                            width={2.0}
                            labels={{
                                visible: false,
                                background: "#bfbfbf",
                                border: {
                                    width: 1,
                                    color: "black",
                                },
                                font: "11px calibri",
                            }}
                            tooltip={{
                                visible: true,
                                format: "{0} x {1}",
                                color: "#FFF",
                            }}
                            visibleInLegend={false}
                        />
                        <ChartSeriesItem
                            name="TargetFlow"
                            type="scatterLine"
                            dashType="dot"
                            data={chart3Data?.series?.[10]?.data}
                            xField="capacity"
                            yField="head"
                            color="#006633"
                            yAxis="Head"
                            markers={{
                                visible: false,
                            }}
                            width={3}
                            tooltip={{
                                visible: true,
                                format: "#.##",
                                color: "#FFF",
                            }}
                            visibleInLegend={false}
                        />
                        <ChartSeriesItem
                            name="Target"
                            type="scatter"
                            data={chart3Data?.series?.[11]?.data}
                            xField="capacity"
                            yField="head"
                            color="blue"
                            yAxis="Head"
                            markers={
                                {
                                    visible: true,
                                    type: "square",
                                    background: "blue",
                                    size: 10
                                }
                            }
                            width={2.0}
                            dashType="dot"
                            labels={{
                                visible: true,
                                background: "#bfbfbf",
                                border: {
                                    width: 1,
                                    color: "black",
                                },
                                font: "11px calibri",
                            }}
                            tooltip={{
                                visible: true,
                                format: "{0} x {1}",
                                color: "#fff"
                            }}
                            visibleInLegend={false}
                        />
                    </ChartSeries>

                    {/* X Axis */}
                    <ChartXAxis>
                        <ChartXAxisItem
                            name="Capacity"
                            title={{
                                text: `${chart3Data?.xAxis?.title?.text}`,
                                font: "16px Mulish",
                                color: "#fff",
                            }}
                            color="#fff"
                            axisCrossingValue={chart3Data?.xAxis?.axisCrossingValue}
                            majorGridLines={{ width: 0.8, color: "#A0A0A0" }}
                            minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: true }}
                            crosshair={{
                                visible: true,
                                width: 1,
                                color: "#005F7C",
                                tooltip: {
                                    visible: true,
                                    format: "#.##",
                                },
                            }}
                            min={0}
                            max={chart3Data?.xAxis?.max}
                            majorUnit={chart3Data?.xAxis?.majorUnit}
                        />
                    </ChartXAxis>
                    {/* Y Axis */}
                    <ChartYAxis>
                        <ChartYAxisItem
                            name="Head"
                            title={{
                                text: `${chart3Data?.yAxis?.[0]?.title?.text}`,
                                font: "16px Mulish",
                                color: "#FF0000",
                            }}
                            min={0}
                            max={chart3Data?.yAxis?.[0]?.max}
                            majorUnit={chart3Data?.yAxis?.[0]?.majorUnit}
                            color="#FF0000"
                            majorGridLines={{ width: 0.8, color: "#A0A0A0" }}
                            minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: true }}
                            crosshair={{ visible: true, width: 1, color: "#005F7C" }}
                        />
                    </ChartYAxis>

                    {/* Tooltip */}
                    <ChartTooltip
                        visible={true}
                        color="red"
                        opacity={1.0}
                        format="Flow= #: value.x # , Head= #: value.y #"
                        render={(props: any) => {
                            const x = props?.point?.value?.x?.toFixed(2);
                            const y = props?.point?.value?.y?.toFixed(2);                        
                            return (
                                <div>{x}, {y}</div>
                            );
                        }}
                    />
                </Chart>
            )}
        </div>
    );
};

export default PowerCurve;
